import BaseAvatar from '@/components/bases/BaseAvatar';

import * as React from 'react';

export interface IInfoCardProps {
  user: any;
  className?: string;
  isProtector?: boolean;
  collapsed?: boolean;
}

export default function InfoCard({ user, className, collapsed, isProtector }: IInfoCardProps) {
  return (
    <div className={className}>
      <div className={`flex items-center rounded-lg p-2 ${collapsed ? 'justify-center' : ''}`}>
        <div className={`flex items-center gap-4 ${collapsed ? 'justify-center' : ''}`}>
          <BaseAvatar
            username={user?.username}
            src={user?.avatar ?? '/images/UserPortraits/avatar.png'}
            className={'wh-[36px]'}
          />
          {collapsed ? null : (
            <div>
              <div className="text-xs text-gray-7 flex items-center">
                {user?.phone ? user?.phone : user?.family?.protector?.phone}
              </div>
              <div className="font-bold text-sm">{user?.username}</div>
              {isProtector && <div className="text-xs text-gray-7">Chủ tài khoản</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
